import { z } from 'zod';

// Helper function to remove non-digit characters and check length
const preprocessPhoneNumber = (val: unknown) => {
    if (typeof val === 'string' && val.trim() === '') {
        return undefined; // Treat empty string as undefined
    }
    if (typeof val === 'string') {
        return val.replace(/[\D]/g, ''); // Remove non-digits
    }
    return val;
};

export const createProfileFormSchema = (t: (key: string, defaultText: string) => string)=>{
    return z.object({
    preferredName: z.string().optional(),
    email: z.preprocess(
        (val) => (val === '' ? undefined : val),
        z.string().email({ message: t("validation_emailFormat", "Invalid email address format.") }).optional()
    ),
    confirmEmail: z.string().optional(), // Initially optional, refined later
    phoneNumber: z.preprocess(
        preprocessPhoneNumber,
        z.string()
            .refine((val) => val === undefined || val.length === 10, t("validation_phoneLength","Phone number must be exactly 10 digits."))
            .optional()
    ),
    streetAddress: z.string().optional(),
    unitAddress: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    zipCode: z.preprocess(
        (val) => (val === '' ? undefined : val),
        z.string().regex(/^\d+$/, { message: t("validation_zipCode", "Zip Code should only contain digits.") }).optional()
    ),
    country: z.string().optional(),
}).superRefine((data, ctx) => {
    // If email is provided, then confirmEmail is required and must match
    if (data.email) {
        if (!data.confirmEmail) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: t("validation_emailConfirm", "Confirm Email is required when email is provided."),
                path: ['confirmEmail'],
            });
        } else if (data.confirmEmail !== data.email) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: t("validation_emailConfirm_match", "Emails do not match."),
                path: ['confirmEmail'],
            });
        }
    }
})
};

export type ProfileFormData = z.infer<ReturnType<typeof createProfileFormSchema>>;